import { FormInput, FormInputProps } from 'modules';
import React from 'react';

const ZpusobBydleniSelect = (props: FormInputProps) => {
  const options = [
    {
      label: 'Vlastné',
      value: 'Vlastné',
    },
    {
      label: 'Nájomné',
      value: 'Nájomné',
    },
    {
      label: 'Podnájom',
      value: 'Podnájom',
    },
    {
      label: 'U rodičov',
      value: 'U rodičov',
    },
    {
      label: 'U príbuzných',
      value: 'U príbuzných',
    },
    {
      label: 'U priateľa/ľky',
      value: 'U priateľa/ľky',
    },
    {
      label: 'Iné',
      value: 'Iné',
    },
  ];

  return <FormInput {...props} type={'select'} options={options} />;
};

export default ZpusobBydleniSelect;
